import { useRequest } from 'ahooks'

import { batchPublishAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/batchPublishAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementPublishBatchButtonProps } from './interface'

export const AnnouncementPublishBatchButton = ({
  uuid
}: AnnouncementPublishBatchButtonProps) => {
  const { message } = useFeedback()

  const { selectedRowKeys, setSelectedRows, reload } = useRemoteTableStore(
    state => pick(state, ['selectedRowKeys', 'setSelectedRows', 'reload'])
  )

  const { loading, runAsync } = useRequest(
    () =>
      batchPublishAnnouncementApi({
        announcementIds: selectedRowKeys as string[]
      }),
    {
      manual: true,
      onSuccess() {
        message.success('批量发布成功')
        setSelectedRows([])
        reload()
      }
    }
  )

  return (
    <ConfirmButton
      ghost
      disabled={selectedRowKeys.length === 0}
      forbiddenStrategy='disable'
      loading={loading}
      message='确定批量发布吗？'
      placement='top'
      type='primary'
      uuid={uuid}
      onConfirm={runAsync}
    >
      批量发布
    </ConfirmButton>
  )
}
